/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { EmailTemplatesIndexQueryParams, EmailTemplatesIndexResponse } from '../types/EmailTemplatesIndex'

/**
 * GET /email-templates
 * @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::index
 */
export async function emailTemplatesIndex(
	params?: EmailTemplatesIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<EmailTemplatesIndexResponse>> {
	return axiosInstance.get('/email-templates', { params, ...config })
}
